<template>
  <v-form @submit.prevent>
    <tiles-form :tile="doc" />
    <v-btn class="mt-5" @click="onSubmit">Submit</v-btn>
  </v-form>
</template>

<script>
// @ is an alias to /src
import TilesForm from "./Form";
import router from "@/router";

export default {
  name: "AdminTileAdd",
  components: {
    TilesForm,
  },
  data() {
    return {
      doc: {},
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      let ref = this.$parent.collection.doc();
      ref
        .set({
          createdOn: new Date(),
          id: ref.id,
          title: this.doc.title,
          arabic: this.doc.arabic,
          category: this.doc.category,
          type: this.doc.type,
          src: this.doc.src ? this.doc.src : null,
        })
        .then(() => {
          router.push({ name: this.$parent.returnRoute });
        })
        .catch((error) => {
          alert("Error adding document: ", error);
        });
    },
  },
};
</script>
